import { getLocalizationStrings } from "../loc/Localization";
import { IUIStrings } from "../loc/IUIStrings";

window.onload= function() {
  // Load localization strings
  let strings: IUIStrings = getLocalizationStrings(window.navigator.language);

  let messageDiv = document.getElementById("message");
  messageDiv.innerHTML = strings.CloningMail;
}